import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
  link: {
    textDecoration: "none",
    width: "90% !important",
    margin: "auto",
    borderRadius: 4,
    fontWeight: "bold",
    alignItems: "center",
    position: "relative",
    boxSizing: "border-box",
    outline: 0,
    border: 0,
    cursor: "pointer",
    verticalAlign: "middle",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: "16px !important",
    paddingRight: "16px !important",
    color: "white !important",
    "&:hover": {
      backgroundColor: tinycolor("#1D2739").darken(15).toHexString()
    },
    "&:focus, &:active": {
      backgroundColor: "#1D2739"
    }
  },
  externalLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none"
  },
  linkActive: {
    backgroundColor: "#1D2739"
  },
  linkNested: {
    paddingLeft: 0,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.secondary.main
    }
  },
  linkIcon: {
    color: "white !important",
    transition: theme.transitions.create("color"),
    minWidth: "40px !important",
    fontSize: "16px !important",
    display: "flex",
    justifyContent: "center",
    letterSpacing: -2,
    fontWeight: "bold"
  },
  linkIconActive: {
    color: "white !important"
  },
  linkText: {
    padding: 0,
    color: "white",
    transition: theme.transitions.create(["opacity", "color"]),
    letterSpacing: -0.5,
    fontWeight: 500,
    fontSize: "14px"
  },
  linkTextActive: {
    color: "white"
  },
  linkTextHidden: {
    // opacity: 0
  },
  nestedList: {
    paddingLeft: theme.spacing(2) + 30
  },
  sectionTitle: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: "#D8D8D880"
  },
  activeParent: {
    backgroundColor: "#1D2739"
  },
  display: {
    display: "none"
  }
}));
